// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__246qs","messages":"Chat_messages__3MpPX","dateDivider":"Chat_dateDivider__2c8bU"};